module.exports = __webpack_public_path__ + "static/media/dtc.bbb1464d.png";